<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { onBeforeRouteLeave } from 'vue-router'
  import { useAppModal } from '@/components/modal'

  const { modal, open, close } = useAppModal()
  defineExpose({ open })

  const search = ref('')

  const activeFilter = ref('produk')
  const isFilterProduk = computed(() => activeFilter.value === 'produk')
  const isFilterPembelian = computed(() => activeFilter.value === 'pembelian')
  const isFilterPenjualan = computed(() => activeFilter.value === 'penjualan')
  const isFilterCustomer = computed(() => activeFilter.value === 'customer')
  const isFilterSupplier = computed(() => activeFilter.value === 'supplier')

  onBeforeRouteLeave(close)
</script>

<template>
  <app-modal
    ref="modal"
    size="medium"
    title="Search">
    <app-search
      v-model="search"
      v-focus />

    <div class="mt-2 min-h-80">
      <div class="flex gap-2 flex-wrap">
        <app-button
          class="btn-filter"
          :class="{ active: isFilterProduk }"
          @click="activeFilter = 'produk'">
          Produk
        </app-button>
        <app-button
          class="btn-filter"
          :class="{ active: isFilterPembelian }"
          @click="activeFilter = 'pembelian'">
          Pembelian
        </app-button>
        <app-button
          class="btn-filter"
          :class="{ active: isFilterPenjualan }"
          @click="activeFilter = 'penjualan'">
          Penjualan
        </app-button>
        <app-button
          class="btn-filter"
          :class="{ active: isFilterCustomer }"
          @click="activeFilter = 'customer'">
          Customer
        </app-button>
        <app-button
          class="btn-filter"
          :class="{ active: isFilterSupplier }"
          @click="activeFilter = 'supplier'">
          Supplier
        </app-button>
      </div>
    </div>
  </app-modal>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .btn-filter {
    @apply border text-xs rounded px-2 py-1 bg-white hover:bg-gray-100;

    &.active {
      @apply bg-primary-500 text-white border-primary-500;
    }
  }
</style>
